import apiClient from "./apiClient";

export const RulesRegulationsService = {
  // -----------------------------------------
  // CATEGORIES API
  // -----------------------------------------
  getCategories: async () => {
    const response = await apiClient.get('/RuleCategories');
    return response.data;
  },
  createCategory: async (data, userId) => {
    const response = await apiClient.post(`/RuleCategories?userId=${userId}`, data);
    return response.data;
  },
  updateCategory: async (id, data, userId) => {
    const response = await apiClient.put(`/RuleCategories/${id}?userId=${userId}`, data);
    return response.data;
  },
  deleteCategory: async (id) => {
    const response = await apiClient.delete(`/RuleCategories/${id}`);
    return response.data;
  },

  // -----------------------------------------
  // ADMIN RULES API
  // -----------------------------------------
  getAdminRules: async (params = {}) => {
    const response = await apiClient.get('/Rules', { params });
    return response.data;
  },
  getRuleById: async (id) => {
    const response = await apiClient.get(`/Rules/${id}`);
    return response.data;
  },
  createRule: async (payload, userId) => {
    const response = await apiClient.post(`/Rules?userId=${userId}`, payload);
    return response.data;
  },
  updateRule: async (id, payload, userId) => {
    const response = await apiClient.put(`/Rules/${id}?userId=${userId}`, payload);
    return response.data;
  },
  deleteRule: async (id, userId) => {
    const response = await apiClient.delete(`/Rules/${id}?userId=${userId}`);
    return response.data;
  },
  publishRule: async (id, userId) => {
    const response = await apiClient.post(`/Rules/${id}/publish?userId=${userId}`);
    return response.data;
  },
  archiveRule: async (id, userId) => {
    const response = await apiClient.post(`/Rules/${id}/archive?userId=${userId}`);
    return response.data;
  },
  getAcknowledgements: async (id) => {
    const response = await apiClient.get(`/Rules/${id}/acknowledgements`);
    return response.data;
  },

  // -----------------------------------------
  // MY RULES API (USER FACING)
  // -----------------------------------------
  getMyRules: async (userId, siteId, wingId, floorId) => {
    const params = { UserId: userId, SiteId: siteId, WingId: wingId, FloorId: floorId };
    const response = await apiClient.get('/MyRules', { params });
    return response.data;
  },
  getMyRuleById: async (id, userId) => {
    const response = await apiClient.get(`/MyRules/${id}?userId=${userId}`);
    return response.data;
  },
  acknowledgeRule: async (id, ruleVersionId, deviceId, userId) => {
    const response = await apiClient.post(`/MyRules/${id}/acknowledge?userId=${userId}`, {
      RuleVersionId: ruleVersionId,
      DeviceId: deviceId
    });
    return response.data;
  }
};
